import Template from '../../component/Template.js';
import { useEffect, useRef } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React from "react";
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import '../../Assets/css/resptable.css'
import '../../Assets/css/responsiveptable.css'
import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import Select from 'react-select';


export default function Attendance() {

    const navigate = useNavigate();
    const isAuth = useAuth();

    if (isAuth === false) {
        navigate("/college/");
    }

    const tableRef = useRef(null);
    const [getexamData, setExamData] = useState([]);
    const [examid, setExamIdData] = useState('');
    const [courses, setCourses] = useState([]);
    const [selectedCourseId, setSelectedCourseId] = useState('');
    const [tableData, setTableData] = useState([]);
    const collegename = localStorage.getItem('username');

    const [loading, setlodaing] = useState(false);
    const [disciplineId, setDisciplineChange] = useState(null);
    const [disciplinetype, setDisciplineTypeChange] = useState(null);
    const [disciplineName, setDisciplineNameChange] = useState(null);
    const [flag, setflag] = useState(false);
    const [disciplinedata, setDisciplineData] = useState([]);
    const [registrationcount, setRegistrationcount] = useState({});

    const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
    const [selectedStudents, setSelectedStudents] = useState([]);

    const [showModal, setShowModal] = useState(false);
    const [showModal1, setShowModal1] = useState(false);
    const handleOpenModal = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleOpenModal1 = () => {
        setShowModal1(true);
    };

    const handleCloseModal1 = () => {
        setShowModal1(false);
    };


    // Holds the fetched students based on discipline
    const currentDate = new Date();

    const { http } = Api();

    const customStyles = {
        menu: (provided) => ({
            ...provided,
            maxHeight: '200px',
            overflowY: 'auto',
        }),
        menuList: (provided) => ({
            ...provided,
            maxHeight: '200px',
            overflowY: 'auto',
            scrollbarWidth: 'thin',
            scrollbarColor: '#888 #f1f1f1',
        }),

        /* Additional custom scrollbar styling for WebKit-based browsers */
        multiValue: (provided) => ({
            ...provided,
            '&::-webkit-scrollbar': {
                width: '8px',
            },
            '&::-webkit-scrollbar-track': {
                background: '#f1f1f1',
            },
            '&::-webkit-scrollbar-thumb': {
                background: '#888',
                borderRadius: '4px',
            },
            '&::-webkit-scrollbar-thumb:hover': {
                background: '#555',
            },
        }),
    };

    let cid = localStorage.getItem("collegeid");

    useEffect(() => {
        const fetchExamData = async () => {
            try {
                const response = await http.get(`College/getAbsenteeMalpracticeExams`);
                setExamData(response.data);
            }
            catch (error) {
                if (error.response.data.http_status === 403 && error.response.data.status_code == "ERR37") {
                    toast.error("Invalid Token");
                    setTimeout(() => {
                        navigate("/college/");
                    }, 5000);

                }
                else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
                    toast.error(error.response.data.message);
                }
                else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR5") {
                    toast.error(error.response.data.message);
                }
                else {
                    toast.error(error.response.data.message);
                }
            }
        };
        fetchExamData();
    }, []);


    const handlExamChange = (selectedOption) => {
        const newExamId = selectedOption.value;
        setExamIdData(newExamId); // Update the state for exam ID
        console.log("Selected examid: " + newExamId);

        // Pass the new exam ID directly to the fetchDataDis function
        fetchDataDis(newExamId);

        // Clear table data when the exam is changed
        setTableData([]);
        setSelectedStudents([]);
    };

    //useEffect(() => {
    const fetchDataDis = async (examid) => {
        try {
            const response = await http.get(`/College/getCollegeOptedDisciplines`, {
                params: {
                    examid: examid,
                    //college_id: cid
                }
            });
            if (response.data.status_code === 'ERR5') {
                setflag(true);
            }
            setDisciplineData(response.data);
        }
        catch (error) {
            if (error.response.data.http_status === 403 && error.response.data.status_code == "ERR37") {
                toast.error("Invalid Token");
                setTimeout(() => {
                    navigate("/college/");
                }, 5000);

            }
            else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
                toast.error(error.response.data.message);
            }
            else {
                toast.error(error.response.data.message);
            }
        }
    };

    // fetchData();
    //}, [examid]);





    const handleDisciplineChange = (selectedOption) => {
        const newDisciplineId = selectedOption.did;
        const newDisciplineType = selectedOption.type;

        // Reset courses and selected course, and clear the table data
        setCourses([]);
        setSelectedCourseId('');
        setTableData([]);  // Clear the table data when discipline changes
        setSelectedStudents([]);

        // Force re-fetch courses even if the same discipline is clicked
        setDisciplineChange(null);  // Temporarily reset to force state change
        setTimeout(() => {
            setDisciplineChange(newDisciplineId);
            setDisciplineTypeChange(newDisciplineType);
            setDisciplineNameChange(selectedOption.value);
        }, 0); // Set to the new value after resetting
    };

    useEffect(() => {
        const fetchCourses = async () => {
            try {
                const response = await http.get('/College/getCollegeDisciplineCourses', {
                    params: {
                        discipline_id: disciplineId,
                        college_course_type: disciplinetype,
                        examid: examid
                    },
                });
                setCourses(response.data || []); // Update course options
            } catch (error) {
                console.error("Error fetching courses:", error);
                setCourses([]); // Clear courses on error
            }
        };

        if (disciplineId && disciplinetype) {
            fetchCourses();
        }
    }, [disciplineId, disciplinetype]);




    const fetchCourseData = async (courseId) => {
        setSelectedCourseId(courseId);

        // Clear old data
        setTableData([]);
        setSelectedStudents([]);

        try {
            const response = await http.get('/College/viewAbsenteeMalpracticeList', {
                params: {
                    examid: examid,
                    discipline_id: disciplineId,
                    courseid: courseId,
                    college_course_type: disciplinetype,
                },
            });

            if (response.data.status_code === 'ERR5') {
                setflag(true);
            }

            setTableData(response.data);
        } catch (error) {
            handleError(error);
        }
    };


    const handleCourseChange = (event) => {

        const courseId = event.target.value;
        fetchCourseData(courseId);
    };


    useEffect(() => {
        if (selectedCourseId) {
            Registrationcount(); // Trigger Registrationcount only after selectedCourseId changes
        }
    }, [selectedCourseId]); // Dependency on selectedCourseId

    const Registrationcount = async () => {
        try {
            const response = await http.get(`College/viewAbsenteeMalpracticeStat`, {
                params: {
                    examid: examid,
                    discipline_id: disciplineId,
                    courseid: selectedCourseId, // Use the passed courseId or the current state
                    college_course_type: disciplinetype // Replace with actual type
                }
            });
            console.log(response.data);
            setRegistrationcount(response.data[0]);
        }
        catch (error) {
            if (error.response.data.http_status === 403 && error.response.data.status_code == "ERR37") {
                toast.error("Invalid Token");
                setTimeout(() => {
                    navigate("/college/");
                }, 5000);

            }
        }
    }

    const confirmApproveAll = async () => {
        try {
            const response = await http.post('/College/principalApprovalAbsenteeMalpractice', {
                examid: examid,
                discipline_id: disciplineId,
                discipline_type: disciplinetype,
                courseid: selectedCourseId,
                students: selectedStudents
            });

            if (response.data.http_status === 200) {
                toast.success(response.data.message);
                setShowModal(false); // Close the modal
                setShowModal1(false);
                fetchCourseData(selectedCourseId);
            } else {
                toast.error(response.data.message || "Failed to approve entries");
            }
        } catch (error) {
            console.error("Error during approval:", error);
            toast.error(error.response.data.message);
        }
    };

    const confirmrevert = async () => {
        try {
            const response = await http.post('/College/principalRevertAbsenteeMalpractice', {
                examid: examid,
                discipline_id: disciplineId,
                discipline_type: disciplinetype,
                courseid: selectedCourseId,
                students: selectedStudents
            });

            if (response.data.http_status === 200) {

                toast.success(response.data.message);
                setShowModal(false); // Close the modal
                setShowModal1(false);
                fetchCourseData(selectedCourseId);

            } else {
                toast.error(response.data.message || "Failed to approve entries");
            }
        } catch (error) {
            console.error("Error during approval:", error);
            toast.error(error.response.data.message);
        }
    };

    const handleError = (error) => {
        if (error.response) {
            const status = error.response.data.http_status;
            const code = error.response.data.status_code;
            if (status === 403 && code === "ERR37") {
                toast.error("Invalid Token");
                setTimeout(() => navigate("/college/"), 5000);
            } else if (status === 429 && code === "ERR33") {
                toast.error(error.response.data.message);
            } else if (status === 500 && code === "ERR5") {
                toast.error("No Data found");
            } else {
                toast.error(error.response.data.message);
            }
        }
    };

    const handleGeneratePDFNew = async () => {
        try {
            const response = await http.get('/College/exampresentabsentmalstatment', {
                params: {
                    examid: examid,
                    discipline_id: disciplineId,
                    college_course_type: disciplinetype,
                    courseid: selectedCourseId
                },
                responseType: 'blob'
            });

            if (response && response.data) {

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${localStorage.getItem('username')}_${disciplineName}_${registrationcount.qpcode}.pdf`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                return Promise.resolve('PDF generated successfully ');

            }

        } catch (error) {
            console.error('Error generating PDF:', error);
            return Promise.reject('Error generating PDF');
        }
    };

    //custom discipline style
    const disciplineStyles = {

        option: (provided, state) => {
            const label = state.data.label || "";
            const suffix = label.split("-")[1]?.trim();  // SF / AIDED

            let color = "black";
            if (suffix === "SF") color = "#252393";
            if (suffix === "AIDED") color = "green";

            if (state.isSelected) {
                return {
                    ...provided,
                    backgroundColor: "#ebebeb",
                    color: color,   // KEEP suffix color even when selected
                    fontWeight: "600",
                };
            }

            return {
                ...provided,
                color: color,
            };
        },

        // THIS makes the selected item in the select box colored
        singleValue: (provided, state) => {
            const label = state.data.label || "";
            const suffix = label.split("-")[1]?.trim();

            let color = "black";
            if (suffix === "SF") color = "#252393";
            if (suffix === "AIDED") color = "green";

            return {
                ...provided,
                color: color,
                fontWeight: "600",
            };
        },
        menu: (provided) => ({
            ...provided,
            maxHeight: '200px',
            overflowY: 'auto',
        }),
        menuList: (provided) => ({
            ...provided,
            maxHeight: '200px',
            overflowY: 'auto',
            scrollbarWidth: 'thin',
            scrollbarColor: '#888 #f1f1f1',
        }),
        multiValue: (provided) => ({
            ...provided,
            '&::-webkit-scrollbar': {
                width: '8px',
            },
            '&::-webkit-scrollbar-track': {
                background: '#f1f1f1',
            },
            '&::-webkit-scrollbar-thumb': {
                background: '#888',
                borderRadius: '4px',
            },
            '&::-webkit-scrollbar-thumb:hover': {
                background: '#555',
            },
        }),
    };

    const handleCheckboxChange = (apaarId) => {

        if (selectedStudents.includes(apaarId)) {
            // Deselect the student
            const student = selectedStudents.filter(id => id !== apaarId)
            setSelectedStudents(student);

            if (student.length === 0) {
                setIsSelectAllChecked(false);
            }

        } else {
            // Select the student
            setSelectedStudents([...selectedStudents, apaarId]);
        }
    };

    const handleSelectAll = () => {

        const allSelected = !isSelectAllChecked;
        setIsSelectAllChecked(allSelected);

        if (allSelected) {
            // Select all students' apaarId
            const allStudentIds = tableData
                .filter((studentDetails) => studentDetails?.exam_attendance_status == 1)
                .map((studentDetails) => studentDetails?.apaar_no);
            setSelectedStudents(allStudentIds);

        } else {
            // Deselect all
            setSelectedStudents([]);
        }
    };





    return (
        <>
            <ToastContainer />
            <Template>

                {loading ? (


                    <div className="container-fluid">
                        <div className="row justify-content-center align-items-center">
                            <div className="col-sm-12">
                                <div className="card h-100">
                                    <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                                        <div className="containeranimate">
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="my-page">

                        <div className="container-fluid">

                            <div className={`modal fade show ${showModal ? 'd-block' : ''}`} style={{ backdropFilter: 'blur(2px)' }}>
                                <div className="modal-dialog modal-dialog-centered" role="document">
                                    <div className="modal-content">
                                        <div className="modal-body">
                                            <div className="modal-toggle-wrapper">
                                                <h4 className="text-center pb-2">Are you sure you want to approve all students?</h4>
                                                <div className="d-flex justify-content-center mt-3">
                                                    <button
                                                        className="btn btn-primary mx-2"
                                                        onClick={confirmApproveAll}
                                                    >
                                                        Approve
                                                    </button>
                                                    <button
                                                        className="btn"
                                                        style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }}
                                                        onClick={handleCloseModal}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={`modal fade show ${showModal1 ? 'd-block' : ''}`} style={{ backdropFilter: 'blur(2px)' }}>
                                <div className="modal-dialog modal-dialog-centered" role="document">
                                    <div className="modal-content">
                                        <div className="modal-body">
                                            <div className="modal-toggle-wrapper">
                                                <h4 className="text-center pb-2">Are you sure you want to revert selected students?</h4>
                                                <div className="d-flex justify-content-center mt-3">
                                                    <button
                                                        className="btn btn-primary mx-2"
                                                        onClick={confirmrevert}
                                                    >
                                                        Revert
                                                    </button>
                                                    <button
                                                        className="btn"
                                                        style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }}
                                                        onClick={handleCloseModal1}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>




                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="card">
                                        <div className="col-md-12">
                                            <div className="card-header">
                                                <div className="py-3 d-flex justify-content-between align-items-center ">
                                                    <h5>Absentee/Malpractice</h5>


                                                </div>


                                            </div>
                                            <div className="card-body">
                                                <div className="txt-aln-jst m-10">
                                                    <p>
                                                        <span className="text-danger">Note: In accordance with the MGU-UGP semester end evaluation timetable,
                                                            the college office is obligated to submit a comprehensive daily report via the portal before 5:00 PM,
                                                            providing a detailed account of student attendance that includes confirmation of all registered
                                                            students' presence, identification of any absent students, and reporting of any academic misconduct
                                                            incidents that may have occurred. <br />
                                                            <b>Please note that it is mandatory to submit this form by clicking the submit button at the end of the page, even if all the registered students are present for the examination.</b>
                                                        </span>
                                                    </p>
                                                </div>


                                                <div className="card-body pdg">

                                                    <div class="table-container">

                                                    </div>
                                                    <div className="table-responsive">

                                                        <div className="form theme-form">
                                                            <div className="card-body custom-input">


                                                                <div className="row">


                                                                    <div className="col-md-4">
                                                                        <label>Exam <span className="errorclr">*</span></label>
                                                                        <Select
                                                                            maxMenuHeight={200}
                                                                            menuPlacement="auto"
                                                                            id="exam_id"
                                                                            name="exam_id"
                                                                            className="basic-select"
                                                                            classNamePrefix="select"
                                                                            options={getexamData.map(exam => ({
                                                                                value: exam.examid,
                                                                                label: exam.examtitle
                                                                            }))}
                                                                            onChange={handlExamChange}

                                                                            placeholder="Select a semester exam..."
                                                                        />
                                                                    </div>

                                                                    <div className="col-md-4">
                                                                        <label>Course Discipline <span className="errorclr">*</span></label>
                                                                        <Select
                                                                            maxMenuHeight={200}
                                                                            menuPlacement="auto"
                                                                            id="discipline_id"
                                                                            name="discipline_id"
                                                                            className="form"
                                                                            styles={disciplineStyles}
                                                                            onChange={handleDisciplineChange}
                                                                            options={Array.isArray(disciplinedata) && disciplinedata.length > 0
                                                                                ? disciplinedata
                                                                                    .sort((a, b) => a.discipline_name.localeCompare(b.discipline_name))
                                                                                    .map(discipline => ({
                                                                                        did: discipline.id,
                                                                                        value: discipline.discipline_name,
                                                                                        label: `${discipline.discipline_name}`, // Combine discipline_name and college_course_type
                                                                                        type: discipline.college_course_type
                                                                                    }))
                                                                                : [{ value: '0', label: 'No data found' }]
                                                                            }
                                                                            value={disciplinedata && Array.isArray(disciplinedata)
                                                                                ? disciplinedata
                                                                                    .filter(discipline =>
                                                                                        discipline.id.toString() === disciplineId &&
                                                                                        discipline.college_course_type === disciplinetype // Added filter for discipline_type
                                                                                    )
                                                                                    .map(discipline => ({
                                                                                        value: discipline.discipline_name,
                                                                                        label: `${discipline.discipline_name}`, // Ensure the selected label matches the dropdown
                                                                                    }))[0]
                                                                                : null}
                                                                        />

                                                                    </div>

                                                                    <div className="col-md-4">
                                                                        <label>Course  <span className="errorclr">*</span></label>
                                                                        <select
                                                                            id="course_id"
                                                                            name="course_id"
                                                                            style={{ color: 'black' }}
                                                                            className="form-select"
                                                                            value={selectedCourseId}
                                                                            onChange={handleCourseChange}

                                                                        >
                                                                            <option value="-1" >Select a course</option>
                                                                            {courses && courses.length > 0 ? (
                                                                                courses.map((course) => (
                                                                                    <option key={course.courseid} value={course.courseid}>
                                                                                        {course.course_name}
                                                                                    </option>
                                                                                ))
                                                                            ) : (
                                                                                <option value="" disabled>No courses available</option>
                                                                            )}
                                                                        </select>
                                                                    </div>
                                                                </div>



                                                                <div className="row">
                                                                    <div
                                                                        className="buttons-container"
                                                                        style={{
                                                                            display: "flex",
                                                                            justifyContent: "flex-end", // Aligns content to the right
                                                                        }}
                                                                    >

                                                                        {Array.isArray(tableData) && tableData.length > 0 && tableData.every(row => row.exam_attendance_status === 2) && (

                                                                            <button
                                                                                className="lbl2 btn btn-primary m-r-10"
                                                                                onClick={handleGeneratePDFNew}
                                                                                title="Download"
                                                                            >
                                                                                <i class="bi bi-arrow-down-square"></i> &nbsp;Absentee Statement
                                                                            </button>
                                                                        )}

                                                                    </div>
                                                                    <table className="table-striped  table-bordered ex-table mb-10" ref={tableRef} id="dataTable">
                                                                        <thead>
                                                                            <tr className="col-cnt-tab-bg-clr" style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                                                <th scope="col" width="10%">QP Code</th>
                                                                                <th scope="col" width="">Course</th>
                                                                                <th scope="col" width="">Registrations</th>
                                                                                <th scope="col" width="">Present </th>
                                                                                <th scope="col" width="">Absentee</th>
                                                                                <th scope="col" width="">Malpractice</th>
                                                                                {/*<th scope="col" width="">Deo Verified</th>
                                        <th scope="col" width="">Forwarded to University</th>*/}
                                                                                <th scope="col" width="">Exam Attendance Status</th>
                                                                            </tr>
                                                                        </thead>

                                                                        <tbody>
                                                                            <tr>
                                                                                <td>{registrationcount.qpcode ? registrationcount.qpcode : "--"}</td>

                                                                                <td>{registrationcount.course_code ? registrationcount.course_code + '-' + registrationcount.course_name : "0"}</td>
                                                                                <td>{registrationcount.registered_count ? registrationcount.registered_count : "0"}</td>
                                                                                <td>{registrationcount.present_count ? registrationcount.present_count : "0"}</td>
                                                                                <td>{registrationcount.absentee_count ? registrationcount.absentee_count : "0"}</td>
                                                                                <td>{registrationcount.malpractice_count ? registrationcount.malpractice_count : "0"}</td>
                                                                                {/*<td>{registrationcount.deo_verified_count ? registrationcount.deo_verified_count : "0"}</td>
                                        <td>{registrationcount.principal_approved_count ? registrationcount.principal_approved_count : "0"}</td>*/}
                                                                                <td>{registrationcount.exam_attendance_status ? registrationcount.exam_attendance_status : "--"}</td>

                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                                <div className="row" style={{ marginTop: '10px' }}>
                                                                    <div className="col-md-12 txt-aln-end">
                                                                        {selectedStudents.length > 0 && (
                                                                            <>
                                                                                <button
                                                                                    className="btn btn-primary me-3"
                                                                                    type="button"
                                                                                    onClick={handleOpenModal}
                                                                                >
                                                                                    Forward to University
                                                                                </button>

                                                                                <button
                                                                                    className="btn btn-danger me-3"
                                                                                    type="button"
                                                                                    onClick={handleOpenModal1}
                                                                                >
                                                                                    Revert to Deo
                                                                                </button>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </div>


                                                                <div class="table-container mt-1">
                                                                    <table className="display dataTable table-striped table-bordered" ref={tableRef} id="dataTable">
                                                                        <thead>
                                                                            <tr className="bg-primary" >

                                                                                <th scope="col" className="text-center" style={{ width: 50 }}>
                                                                                    {Array.isArray(tableData) && tableData.length > 0 && tableData.some(row => row.exam_attendance_status === 1) && (
                                                                                        <input id="select-all" type="checkbox"
                                                                                            onChange={handleSelectAll}
                                                                                            checked={isSelectAllChecked} />
                                                                                    )}

                                                                                </th>
                                                                                <th scope="col" width="8%">Slno</th>
                                                                                <th scope="col" width="20%">PRN <br />
                                                                                    APAAR </th>
                                                                                <th scope="col" width="20%">Name</th>
                                                                                <th scope="col" width="20%">Admitted Discipline</th>
                                                                                <th scope="col" width="10%">Paper Type</th>
                                                                                <th scope="col" width="10%">Attendance</th>
                                                                                <th scope="col" width="12%">Status</th>


                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {tableData.length > 0 ? (
                                                                                tableData.map((row, index) => (
                                                                                    <tr key={index}>
                                                                                        <td scope="row">
                                                                                            {row.exam_attendance_status === 1 ? (
                                                                                                <input type="checkbox" value={row.apaar_no}
                                                                                                    checked={selectedStudents.includes(row.apaar_no)}
                                                                                                    onChange={() => handleCheckboxChange(row.apaar_no)} />
                                                                                            ) : (
                                                                                                row.exam_attendance_status === 2 ? (
                                                                                                    <span class="badge badge-success text-white rounded-pill"><i class="fa fa-check" aria-hidden="true"></i></span>

                                                                                                ) : row.exam_attendance_status === 3 ? (

                                                                                                    <span class="badge badge-danger text-white rounded-pill">x</span>

                                                                                                ) : null
                                                                                            )}
                                                                                        </td>
                                                                                        <td>{index + 1}</td>
                                                                                        <td>
                                                                                            <span style={{ fontWeight: "600", color: "#555", fontSize: "13px" }}>
                                                                                                PRN:
                                                                                            </span> {row.PRN}
                                                                                            <br />

                                                                                            <span style={{ fontWeight: "600", color: "#555", fontSize: "13px" }}>
                                                                                                APAAR:
                                                                                            </span> {row.apaar_no}
                                                                                        </td> {/* Replace 'column1' with actual response keys */}
                                                                                        <td>{row.studentname}</td>
                                                                                        <td>{row.student_discipline}-{row.student_course_type}</td>
                                                                                        <td>{row.paper_identifier}</td>
                                                                                        <td className={
                                                                                            row.exam_attendance === 'P' ? 'status-present' :
                                                                                                row.exam_attendance === 'A' ? 'status-absent' :
                                                                                                    row.exam_attendance === 'M' ? 'status-malpractice' : 'status-not-marked'
                                                                                        }>
                                                                                            {row.exam_attendance === 'P' ? 'Present' :
                                                                                                row.exam_attendance === 'A' ? 'Absent' :
                                                                                                    row.exam_attendance === 'M' ? 'Malpractice' : 'Not yet marked'}
                                                                                        </td>
                                                                                        <td className={
                                                                                            row.exam_attendance_status === 1 ? 'status-deo-entered' :
                                                                                                row.exam_attendance_status === 2 ? 'status-forward-university' : 'text-danger'
                                                                                        }>
                                                                                            {row.exam_attendance_status === 1 ? 'DEO Entered' :
                                                                                                row.exam_attendance_status === 2 ? 'Forwarded to University' : row.exam_attendance_status === 3 ? 'Reverted to DEO' : ''}
                                                                                        </td>

                                                                                    </tr>
                                                                                ))
                                                                            ) : (
                                                                                <tr>
                                                                                    <td colSpan="7">No data available</td>
                                                                                </tr>
                                                                            )}


                                                                        </tbody>
                                                                    </table>


                                                                </div>

                                                            </div>



                                                        </div>



                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}


            </Template>
        </>
    );
}
